module.exports = __webpack_public_path__ + "static/img/peitu3-2.f38436d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/purchaseCoordination/peitu3-2.png
// module id = 597
// module chunks = 12